import type { EntityConfig } from '@/v2/framework/registry/types'
import { createTournamentRoundsView } from './grid/view'

export default {
  id: 'tournament-rounds',
  name: 'tournament-rounds',
  title: 'metadata.tournament_rounds',
  position: 4,
  create: (ctx) => createTournamentRoundsView(ctx),
} satisfies EntityConfig
